export class GetCampaignData {
    static readonly type = '[Campaign] Get';
    constructor(public pageIdex: number, public filterResult: {}) {}
}